import store from "data/store";
import * as s from "data/reducers/selectors";
import { persistor } from "data/store";
import { SiteType } from "data/types";
import cloneDeep from "lodash/cloneDeep";

export const isOnline = () => s.isOnlineSelector(store.getState());

export const cardsCards = () => s.cardsCardsSelector(store.getState());

export const docsItemUri = () => s.docsItemUriSelector(store.getState());

export const currentItemUri = () => s.currentItemUriSelector(store.getState());

export const accessToken = () => s.loginAccessTokenSelector(store.getState());

export const correlationId = () =>
    s.userCorrelationIdSelector(store.getState());

export const sitesSelector = () => s.userSitesSelector(store.getState());

export const globalSitesAreaSelector = () =>
    sitesSelector().find(
        (s) =>
            s.siteType === SiteType.GlobalSites && s.webDavName === "GLOBALSITE"
    );

export const userLanguage = (defaultLocale = undefined) =>
    s.userLanguageSelector(store.getState()) ?? defaultLocale;

export const userId = () => s.userIdSelector(store.getState());

export const userName = () => s.userNameSelector(store.getState());

export const clonedUser = () => cloneDeep(store.getState().user);

export const settingValue = (name) =>
    s.settingValueSelector(name, store.getState());

export const swRegistrationSelector = () =>
    s.swRegistrationSelector(store.getState());

export const dispatch = (action) => store.dispatch(action);

export const getNotification = (notificationId) =>
    s.notificationSelector(store.getState(), notificationId)?.[0] || {};

export const getFirstItemUri = () =>
    s.docsActiveRowItemUriSelector(store.getState(), 0);

export { persistor };
